/* Orléa — section UGC : lecture des vidéos (2026-07-29)

   🔴 POURQUOI PAS D'`autoplay` EN DUR DANS LE HTML
   Cinq vidéos qui se téléchargent et jouent en même temps = page lourde et
   batterie vidée sur mobile. Un IntersectionObserver ne lance QUE ce qui est
   visible et met le reste en pause. Avec `preload="none"` + poster, rien n'est
   téléchargé tant que la section n'est pas atteinte.

   ⚠ `playsinline` est OBLIGATOIRE : sans lui, iOS ouvre la vidéo en plein
     écran au lieu de la jouer dans la page.
   ⚠ `muted` doit être posé EN ATTRIBUT ET en propriété JS : Safari ignore
     parfois l'attribut seul et bloque alors la lecture automatique.
   ⚠ Le son au clic COUPE les autres vidéos — sinon deux bandes-son se
     superposent.

   🔴 BOUTON SON MASQUÉ SI LA VIDÉO N'A PAS DE PISTE AUDIO (correctif 2026-07-29,
   repéré par Simon). J'avais encodé les vidéos avec `-an` pour alléger, ce qui
   rendait le bouton décoratif : il n'y avait rien à démuter. Les vidéos ont été
   réencodées avec leur son, MAIS l'une d'elles n'a jamais eu d'audio à la source.
   → On détecte l'absence de piste et on retire le bouton, plutôt que d'offrir
     une commande sans effet. */

if (!customElements.get('orlea-ugc')) {
  class OrleaUgc extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-ougc-rail]');
      if (!this.rail) return;
      this.videos = Array.from(this.querySelectorAll('.ougc-video'));
      if (!this.videos.length) return;

      this.videos.forEach(function (v) {
        v.muted = true;
        v.loop = true;
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        v.removeAttribute('controls');
      });

      this.initVisibilite();
      this.initSon();
      this.initFleches();
    }

    /* Une vidéo sans piste audio ne doit pas afficher de bouton son.
       La détection n'est fiable qu'une fois les métadonnées chargées, et les
       propriétés diffèrent selon le navigateur : Firefox expose `mozHasAudio`,
       Chrome/Safari `webkitAudioDecodedByteCount` ou `audioTracks`.
       Dans le doute (aucune propriété disponible), on GARDE le bouton. */
    verifierAudio(v) {
      var btn = v.closest('.ougc-cadre');
      btn = btn && btn.querySelector('[data-ougc-son]');
      if (!btn) return;

      var aDuSon = null;
      if (typeof v.mozHasAudio === 'boolean') {
        aDuSon = v.mozHasAudio;
      } else if (v.audioTracks && typeof v.audioTracks.length === 'number') {
        aDuSon = v.audioTracks.length > 0;
      } else if (typeof v.webkitAudioDecodedByteCount === 'number') {
        aDuSon = v.webkitAudioDecodedByteCount > 0;
      }

      if (aDuSon === false) {
        btn.remove();
        var lg = v.closest('.ougc-cadre').querySelector('.ougc-legende');
        if (lg) lg.style.right = '14px';
      }
    }

    initVisibilite() {
      var self = this;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (v.preload === 'none') v.preload = 'auto';
            var p = v.play();
            if (p && p.then) {
              p.then(function () { self.verifierAudio(v); })
               .catch(function () { /* lecture refusée : le poster reste */ });
            }
          } else {
            v.pause();
            if (!v.muted) v.muted = true;
            var cadre = v.closest('.ougc-cadre');
            var btn = cadre && cadre.querySelector('[data-ougc-son]');
            if (btn) btn.setAttribute('aria-pressed', 'false');
          }
        });
      }, { threshold: 0.35 });

      var obs = this.obs;
      this.videos.forEach(function (v) {
        obs.observe(v);
        // filet : si la lecture ne démarre jamais, on vérifie quand même l'audio
        v.addEventListener('loadeddata', function () { self.verifierAudio(v); }, { once: true });
      });

      this._surVisibilite = function () {
        if (document.hidden) this.videos.forEach(function (v) { v.pause(); });
      }.bind(this);
      document.addEventListener('visibilitychange', this._surVisibilite);
    }

    initSon() {
      this._surSon = [];
      var self = this;
      this.querySelectorAll('[data-ougc-son]').forEach(function (btn) {
        var handler = function () {
          var cadre = btn.closest('.ougc-cadre');
          var v = cadre && cadre.querySelector('.ougc-video');
          if (!v) return;
          var activer = v.muted;

          self.videos.forEach(function (autre) { autre.muted = true; });
          self.querySelectorAll('[data-ougc-son]').forEach(function (b) {
            b.setAttribute('aria-pressed', 'false');
          });

          if (activer) {
            v.muted = false;
            btn.setAttribute('aria-pressed', 'true');
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          }
        };
        btn.addEventListener('click', handler);
        self._surSon.push([btn, handler]);
      });
    }

    initFleches() {
      this._surNav = [];
      var rail = this.rail;
      var self = this;
      this.querySelectorAll('[data-ougc-dir]').forEach(function (btn) {
        var dir = btn.getAttribute('data-ougc-dir') === 'next' ? 1 : -1;
        var handler = function () {
          var item = rail.querySelector('.ougc-item');
          if (!item) return;
          var pas = item.getBoundingClientRect().width + 16;
          rail.scrollBy({ left: dir * pas, behavior: 'smooth' });
        };
        btn.addEventListener('click', handler);
        self._surNav.push([btn, handler]);
      });
    }

    disconnectedCallback() {
      if (this.obs) { this.obs.disconnect(); this.obs = null; }
      if (this._surVisibilite) document.removeEventListener('visibilitychange', this._surVisibilite);
      if (this._surSon) { this._surSon.forEach(function (p) { p[0].removeEventListener('click', p[1]); }); this._surSon = null; }
      if (this._surNav) { this._surNav.forEach(function (p) { p[0].removeEventListener('click', p[1]); }); this._surNav = null; }
    }
  }
  customElements.define('orlea-ugc', OrleaUgc);
}
